<template>
  <div class="main-upload-progress">
    <div class="content-layout">
      <div class="title-layout">
        <span class="icon">
          <v-icon color="primary">mdi-progress-upload</v-icon>
        </span>
        <span class="title text">upload ID :</span>
        <span class="id text">{{ upload_id }}</span>
      </div>
      <div class="text-layout">
        <div class="progress-layout">
          <span class="text-success">{{ success }}</span>
          <span class="text-operator"> / </span>
          <span class="text-total">{{ total }}</span>
        </div>
        <div class="actions-layout">
          <v-icon>mdi-format-list-bulleted</v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      upload_id: '00000'
    }
  },

  props: {
    total: {
      type: Number,
      default: 100
    },
    success: {
      type: Number,
      default: 50
    }
  }
}
</script>

<style lang="css" scoped>
.main-upload-progress {
  width: 100%;
  height: 100%;
  /* background: red; */
  color: var(--v-primary-base);
  padding-top: 16px;
  padding-bottom: 16px;
}

.content-layout {
  height: 100%;
  /* background: yellow; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-color: #e0e0e0;
  border-width: 1px;
  border-style: solid;
  border-radius: 5px;
}

.content-layout .title-layout {
  font-size: 20px;
  text-transform: capitalize;
  padding-left: 16px;
  padding-right: 16px;
  font-weight: 300;
  /* background: blue; */
}

.content-layout .text-layout {
  display: flex;
  align-items: flex-end;
  font-size: 30px;
  padding-left: 16px;
  padding-right: 16px;
}

.text-layout .text-success {
  color: var(--v-success-base);
  font-weight: 200;
}

.text-layout .text-operator {
  color: var(--v-primary-base);
  font-weight: 100;
}

.text-layout .text-total {
  color: var(--v-primary-base);
  font-weight: ภจจ;
}

.text-layout .progress-layout {
  /* background: pink; */
  padding: 0 10px 0 10px;
}

.text-layout .actions-layout i {
  /* background: orange; */
  color: var(--v-primary-base);
}
</style>
